import React from 'react';
import { graphql, compose } from 'react-apollo';
import { getPointsEarnedStatistics } from './queries/queries';
import { PointsDistribution } from '../../common/charts/pointsDistribution';
import PointsEarnedWidget from '../../common/widgets/pointsEarned';
import DataProcessor from '../../common/dataProcessors/pointsEarnedDataProcessor';
import AllTimeRevivalDatesWidget from '../../../../widgets/allTime/allTimeRevivalDatesWidget';
import { ErrorBoundary } from "../../../../errorBoundary/errorBoundary";

class PointsEarned extends AllTimeRevivalDatesWidget {
  get statisticsData() {
    return this.props.data.statistics.churchManager.church.allTime.totalPointsEarned;
  }

  get dataProcessor() {
    return new DataProcessor(this.apiData, 'all time');
  }

  render() {
    return(
      <PointsEarnedWidget data={this.dataProcessor.data}
                          loading={this.props.data.loading}
                          title="All Time Seeds"
                          comment={this.comment}>
        <PointsDistribution data={this.dataProcessor.chartData}
                            pointTooltip={this.dataProcessor.pointTooltip}
                            tickValues={this.tickValues}
                            tickFormat={this.tickFormat} />
      </PointsEarnedWidget>
    );
  }
}

export default compose(
  graphql(getPointsEarnedStatistics,
    {
      options: {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true //e.vasilevsky TODO: make it default after updating react-apollo to the latest version
      }
    }),
  ErrorBoundary
)(PointsEarned);



// WEBPACK FOOTER //
// ./src/components/pages/statistics/church/allTime/pointsEarned.js